module.exports = __webpack_public_path__ + "img/es-ct.46e9ce9e.svg";